import React from 'react';
import { Box, Copy, Icon, IconWrapper } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import themeStyles from './ProductLines.style';

const ProductLinesCopy = themeStyles.apply(Copy, 'ProductLinesCopy');
const ProductLinesTitleContainer = themeStyles.apply(Box, 'ProductLinesTitleContainer');

const ProductLinesTitle = () => {
  const { t } = useTranslation();
  return (
    <ProductLinesTitleContainer>
      <IconWrapper>
        <Icon name="shopForTires" />
      </IconWrapper>
      <ProductLinesCopy>{t('Sub-apps.Dealers.productLinesCarriedLabel')}</ProductLinesCopy>
    </ProductLinesTitleContainer>
  );
};

export default ProductLinesTitle;
